import { memo } from "react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state/product";

import { AnchorButtonsView } from "./AnchorButtons.view";

const AnchorButtonsBase = () => {
  const { anchorButtons: anchors } = useSectionSettings<ProductHeroSettings>();

  if (anchors.length === 0) {
    return null;
  }

  return <AnchorButtonsView anchors={anchors} />;
};

export const AnchorButtons = memo(AnchorButtonsBase);
